import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { noop } from 'lodash';
import { withClickTracking } from 'components/core/library/tracking-utils';

/**
 * Base component for links.
 *
 * **Base CSS Class:** `ph-link`
 */

// TODO: Refactor withClickTracking/destructure props without HOC
const enhance = withClickTracking;

export function CoreLink({
	children, href, to, handleClick, onClick, className, target, rel, getRef, as
}, context) {
	// Render as button if explicitly requested OR if there's a click handler without navigation
	// Note: onClick defaults to noop from HOC, so we check it's a real handler
	const hasRealClickHandler = onClick && onClick !== noop;
	const shouldRenderAsButton = as === 'button' || (hasRealClickHandler && !href && !to);

	if (shouldRenderAsButton) {
		return (
			<button
				type="button"
				onClick={handleClick}
				ref={getRef}
				className={classnames(className, 'ph-link inner-accordion-safe')}
			>
				{children}
			</button>
		);
	}

	return to && context.router ? (
		<Link
			to={to}
			rel={rel}
			ref={getRef}
			onClick={handleClick}
			className={classnames(className, 'ph-link inner-accordion-safe')}
			target={target}
		>
			{children}
		</Link>
	) : (
		<a
			onClick={handleClick}
			href={href || to}
			rel={rel}
			ref={getRef}
			className={classnames(className, 'ph-link inner-accordion-safe')}
			target={target}
		>
			{children}
		</a>
	);
}

CoreLink.propTypes = {
	/** Target of the link */
	href: PropTypes.string,
	to: PropTypes.string,
	rel: PropTypes.string,
	getRef: PropTypes.func,
	children: PropTypes.node,
	handleClick: PropTypes.func,
	className: PropTypes.string,
	target: PropTypes.string,
	/** Render as a different element. Use 'button' for click handlers without navigation. Auto-detected when onClick exists without href/to. */
	as: PropTypes.oneOf(['button'])
};

CoreLink.contextTypes = {
	router: PropTypes.object
};

export default enhance(CoreLink);
